import {TranslocoService} from '@ngneat/transloco';

export function apiDateToString(date) {
  const str_date = date.toString();
  return `${str_date.substring(0, 4)}-${str_date.substring(4, 6)}-${str_date.substring(6, 8)}
        ${str_date.substring(8, 10)}:${str_date.substring(10, 12)}:${str_date.substring(12, 14)}`;
}
export function apiDateToStringNoTime(date) {
  const str_date = date.toString();
  return `${str_date.substring(0, 4)}-${str_date.substring(4, 6)}-${str_date.substring(6, 8)}`;
}

export function dateFromSpaToEng(date) {
  const str_date = date.toString();
  return `${str_date.substring(4, 8)}${str_date.substring(2, 4)}${str_date.substring(0, 2)}`;
}

export function dateFromEngToSpa(date) {
  const str_date = date.toString();
  return `${str_date.substring(6, 8)}-${str_date.substring(4, 6)}-${str_date.substring(0, 4)}`;
}
export function dateFromEngToSpaSlashes(date) {
  const str_date = date.toString();
  return `${str_date.substring(6, 8)}/${str_date.substring(4, 6)}/${str_date.substring(0, 4)}`;
}

export function userHasPermission(permission: string) {
  const userPermissionsArray = localStorage.getItem('permissions');
  if (userPermissionsArray) {
    return userPermissionsArray.indexOf(permission) !== -1;
  } else {
    return false;
  }
}

export function  showItem(item: string) {
  const isLoggedin = localStorage.getItem('isLoggedin') === 'true';
  const idRole = +localStorage.getItem('id_role');
  if (item === 'mis_anuncios') {
    return isLoggedin;
  } else if (item === 'moderate') {
    return isLoggedin && idRole === roles.EXPERTO;
  } else if (item === 'admin') {
    return isLoggedin && (idRole === roles.EXPERTO || idRole === roles.ADMINISTRADOR);
  } else if (item === 'stats') {
    return isLoggedin && (idRole === roles.EXPERTO || idRole === roles.ADMINISTRADOR);
  } else if (item === 'ajustes') {
    return isLoggedin && idRole === roles.ADMINISTRADOR;
  } else if (item === 'mis_recursos') {
    return isLoggedin;
  } else if (item === 'mis_enlaces') {
    return isLoggedin;
  } else if (item === 'messages') {
    return isLoggedin;
  } else if (item === 'nuevo_anuncio') {
    return isLoggedin;
  } else if (item === 'nuevo_enlace') {
    return isLoggedin;
  } else if (item === 'editar_enlace') {
    return isLoggedin;
  } else if (item === 'editar_anuncio') {
    return isLoggedin;
  } else if (item === 'nuevo_recurso') {
    return isLoggedin;
  } else if (item === 'editar_recurso') {
    return isLoggedin;
  } else if (item === 'resto_de_usuarios') {
    return isLoggedin && idRole === roles.EXPERTO;
  } else if (item === 'explore') {
    return isLoggedin;
  } else if (item === 'archive') {
    return isLoggedin;
  } else if (item === 'board') {
    return isLoggedin;
  } else if (item === 'my_contributions') {
    return isLoggedin;
  }

}

export function scrollToElement(elementString: string, isClass = false) {
  // Checks element exists in DOM and then scrolls down to it. By default looks for element id, use isClass == true to look for classes
  // Timeout of 2 seconds.
  let element = '';
  if (isClass) {
    element = `.${elementString}`;
  } else {
    element = `#${elementString}`;
  }
  let counter = 0;
  const scrollAttempt = setInterval(() => {
    if (document.querySelector(element)) {
      clearInterval(scrollAttempt);
      document.querySelector(element).scrollIntoView({
        behavior: 'smooth'
      });
      return;
    }
    if (counter++ >= 100) {
      clearInterval(scrollAttempt);
      console.log(`Timeout: Could not find element ${element} to scroll to`);
    }
  }, 20);
}

export function onLoggedout() {
  localStorage.setItem('isLoggedin', 'false');
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  localStorage.removeItem('permissions');
}

export const roles = {
  MIEMBRO: 1,
  ARTISTA: 2,
  EXPERTO: 3,
  ADMINISTRADOR: 4
};

export const mobileWidth = 450;

export function getRoleLabel(idRole) {
  if (idRole === 1) {
    return 'Miembr@';
  } else if (idRole === 2) {
    return 'Artista';
  } else if (idRole === 3) {
    return 'Expert@';
  } else if (idRole === 4) {
    return 'Gestión';
  }
}

export const typeLabels = {
  photo: 'Foto',
  audio: 'Audio',
  video: 'Video',
  document: 'Documento'
};

export function getTypeLabels(type: string, translocoService: TranslocoService) {
  if (type === 'photo') {
    return translocoService.translate('common.photo');
  } else if (type === 'audio') {
    return translocoService.translate('common.audio');
  } else if (type === 'video') {
    return translocoService.translate('common.video');
  } else if (type === 'document') {
    return translocoService.translate('common.document');
  }

}

export const countries = ['Sahara Occidental', 'España', 'Afganistán', 'Albania', 'Alemania', 'Andorra', 'Angola', 'Antigua y Barbuda', 'Arabia Saudita', 'Argelia',
  'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaiyán', 'Bahamas', 'Bangladés', 'Barbados', 'Baréin', 'Bélgica', 'Belice', 'Benín', 'Bielorrusia', 'Birmania', 'Bolivia', 'Bosnia y Herzegovina', 'Botsuana', 'Brasil', 'Brunéi', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Bután', 'Cabo Verde', 'Camboya', 'Camerún', 'Canadá', 'Catar', 'Chad', 'Chile', 'China', 'Chipre', 'Ciudad del Vaticano', 'Colombia', 'Comoras', 'Corea del Norte', 'Corea del Sur', 'Costa de Marfil', 'Costa Rica', 'Croacia', 'Cuba', 'Dinamarca', 'Dominica', 'Ecuador', 'Egipto', 'El Salvador', 'Emiratos Árabes Unidos', 'Eritrea', 'Eslovaquia', 'Eslovenia', 'Estados Unidos', 'Estonia', 'Etiopía', 'Filipinas', 'Finlandia', 'Fiyi', 'Francia', 'Gabón', 'Gambia', 'Georgia', 'Ghana', 'Granada', 'Grecia', 'Guatemala', 'Guyana', 'Guinea', 'Guinea ecuatorial', 'Guinea-Bisáu', 'Haití', 'Honduras', 'Hungría', 'India', 'Indonesia', 'Irak', 'Irán', 'Irlanda', 'Islandia', 'Islas Marshall', 'Islas Salomón', 'Israel', 'Italia', 'Jamaica', 'Japón', 'Jordania', 'Kazajistán', 'Kenia', 'Kirguistán', 'Kiribati', 'Kuwait', 'Laos', 'Lesoto', 'Letonia', 'Líbano', 'Liberia', 'Libia', 'Liechtenstein', 'Lituania', 'Luxemburgo', 'Madagascar', 'Malasia', 'Malaui', 'Maldivas', 'Malí', 'Malta', 'Marruecos', 'Mauricio', 'Mauritania', 'México', 'Micronesia', 'Moldavia', 'Mónaco', 'Mongolia', 'Montenegro', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Nicaragua', 'Níger', 'Nigeria', 'Noruega', 'Nueva Zelanda', 'Omán', 'Países Bajos', 'Pakistán', 'Palaos', 'Palestina', 'Panamá', 'Papúa Nueva Guinea', 'Paraguay', 'Perú', 'Polonia', 'Portugal', 'Reino Unido', 'República Centroafricana', 'República Checa', 'República de Macedonia', 'República del Congo', 'República Democrática del Congo', 'República Dominicana', 'República Sudafricana', 'Ruanda', 'Rumanía', 'Rusia', 'Samoa', 'San Cristóbal y Nieves', 'San Marino', 'San Vicente y las Granadinas', 'Santa Lucía', 'Santo Tomé y Príncipe', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leona', 'Singapur', 'Siria', 'Somalia', 'Sri Lanka', 'Suazilandia', 'Sudán', 'Sudán del Sur', 'Suecia', 'Suiza', 'Surinam', 'Tailandia', 'Tanzania', 'Tayikistán', 'Timor Oriental', 'Togo', 'Tonga', 'Trinidad y Tobago', 'Túnez', 'Turkmenistán', 'Turquía', 'Tuvalu', 'Ucrania', 'Uganda', 'Uruguay', 'Uzbekistán', 'Vanuatu', 'Venezuela', 'Vietnam', 'Yemen', 'Yibuti', 'Zambia', 'Zimbabue'];

export function serverCoordinatesToOlMap(serverCoordinates: string) {
  const c = serverCoordinates.split(',');
  return [+(c[1]).trim(), +c[0]];
}

export function OlCoordinatesToServer(olCoordinates) {
  console.log(olCoordinates);
  return `${olCoordinates[1]}, ${olCoordinates[0]}`;
}

export function formatBytes(bytes) {
  if (bytes === 0) { return '0 Bytes'; }
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
